import React from 'react';
import { FormattedMessage } from 'react-intl';
import ErrorPage from '../components/ErrorPage';
import Button from '@atlaskit/button/new';
import { usePageViewedEvent } from '../utilities/analytics/analytics-web-client';
import messages from './EmailConfirmationInvalidTokenErrorPage.messages';
import { Link } from 'react-router-dom';

export const pageId = 'emailConfirmationInvalidTokenErrorPage';

/**
 * This page handles the case when the email confirmation token is invalid.
 *
 * It is separated entirely because it does not render the form that users use to change their email
 * if they have a valid token.
 */
export const EmailConfirmationInvalidTokenErrorPage = () => {
  usePageViewedEvent(pageId);

  return (
    <ErrorPage title={<FormattedMessage {...messages.invalidTokenTitle} />}>
      <p data-testid="email-confirmation-error-container-idf-testid">
        <FormattedMessage {...messages.invalidTokenDescription} />
      </p>
      <p className="error-action">
        <Link to="/login">
          <Button appearance="primary" testId="email-confirmation-error-page-button-idf-testid">
            <FormattedMessage {...messages.invalidTokenReturnToLoginButton} />
          </Button>
        </Link>
      </p>
    </ErrorPage>
  );
};

export default EmailConfirmationInvalidTokenErrorPage;
